import { useState, useEffect, memo, useRef, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./CollectMemories.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import CheckIcon from '@mui/icons-material/Check';
import html2canvas from "html2canvas";
import { GameContext } from "../../GameContext";
import apiManager from '../../ApiManager';
const CollectMemories = ({ setModalType, arg, addModalType }) => {
    const MaxCount = 3;
    const [inProp, setInProp] = useState(false);
    const pageRef = useRef(null);
    const [state, set_state] = useState("edit");//edit share
    const [count, set_count] = useState(-1);
    const { tempEvent } = useContext(GameContext);
    const [photos, set_photos] = useState([]);

    useEffect(() => {
        console.log("tempEvent", tempEvent);
        console.log("arg", arg);
        const _photos = arg.overlayAlbumArr.map((v, k) => {
            return { img: v.event_polaroids_url, selected: false };
        });
        console.log("_photos", _photos);
        if (_photos.length > 0 && _photos.length < 4) {
            while (_photos.length < 4) {
              _photos.push(
                ..._photos.slice(0, 4 - _photos.length).map(photo => ({ ...photo }))
              );
            }
          }
          
        console.log("_photos after", _photos);
        set_photos(_photos);
        apiManager.fetchGet(`collaborative-log/${tempEvent.events_id}/random-count`, {}, 0).then(res => {
            console.log("res", res);
            set_count(MaxCount - res.random_count);
        });
        setInProp(true);
    }, []);
    useEffect(() => {
        switch (state) {
            case "edit":
                window.updateTitle('製作拍貼');
                break;
            case "share":
                window.updateTitle('分享');
                break;
        }
    }, [state]);
    function shuffle() {
        apiManager.fetchPut(`collaborative-log/${tempEvent.events_id}/random-count`, {}, 0).then(res => {
            set_count(MaxCount - res.random_count);
            set_photos(prev => {
                // 分离选中的照片和未选中的照片
                const selectedPhotos = prev.map((photo, index) => ({ ...photo, originalIndex: index })).filter(photo => photo.selected);
                const unselectedPhotos = prev.map((photo, index) => ({ ...photo, originalIndex: index })).filter(photo => !photo.selected);
                // 随机排序未选中的照片
                const shuffledUnselectedPhotos = unselectedPhotos.sort(() => Math.random() - 0.5);
                // 将照片放回原来的位置
                const newPhotos = prev.map((photo, index) => {
                    const selectedPhoto = selectedPhotos.find(p => p.originalIndex === index);
                    return selectedPhoto ? selectedPhoto : shuffledUnselectedPhotos.shift();
                });
                return newPhotos;
            });
        });
    }

    const handleScreenshot = async () => {
        const canvas = await html2canvas(pageRef.current, { useCORS: true });
        const context = canvas.getContext('2d');

        // 获取canvas的像素数据
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        // 遍历像素数据，将 #F4F4F4 颜色替换为透明色
        /* for (let i = 0; i < data.length; i += 4) {
            if (data[i] === 255 && data[i + 1] === 255 && data[i + 2] === 255 && data[i + 3] === 255) {
                data[i + 3] = 0; // 将alpha值设为0
            }
        } */

        // 将处理后的像素数据放回canvas
        context.putImageData(imageData, 0, 0);

        // 将canvas导出为blob
        const dataUrl = canvas.toDataURL('image/png', 1);
        const blob = await dataUrlToBlob(dataUrl);
        const imageBlobUrl = URL.createObjectURL(blob);

        if (navigator.share) {
            try {
                const file = new File([blob], 'image.png', { type: 'image/png' });
                await navigator.share({
                    title: '分享图片',
                    text: '',
                    files: [file],
                });
            } catch (error) {
                console.error('分享失败', error);
            }
        } else {
            downloadImage(imageBlobUrl);
        }
    };
    const downloadImage = (imageBlobUrl) => {
        const link = document.createElement('a');
        link.href = imageBlobUrl;
        link.target = "_blank";
        link.download = 'image.png'; // 设置下载文件的默认名称
        document.body.appendChild(link);
        link.click();
    };
    const dataUrlToBlob = async (dataUrl) => {
        const res = await fetch(dataUrl);
        return await res.blob();
    };
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "CollectMemories"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.view}>
                                    <img src="./assets/ui/back.png" className={styleUi.backBtn} onClick={e => {
                                        if (state === "share")
                                            set_state("edit");
                                        else
                                            setInProp(false);
                                    }} />

                                    <div ref={pageRef} className={`${styleUi.genPanel} ${state === "edit" ? "" : styleUi.share}`}>
                                        <div className={styleUi.panel}>
                                            {photos.slice(0, 4).map((v, k) => {
                                                return <div key={k} className={styleUi.item}>
                                                    <img className={styleUi.photo} src={v.img} />
                                                    <div className={`${styleUi.pin}`} onClick={e => {
                                                        set_photos(prev => {
                                                            const _prev = [...prev];
                                                            _prev[k].selected = !_prev[k].selected;
                                                            return _prev;
                                                        })
                                                    }}>
                                                        {state === "edit" &&
                                                            <>
                                                                {
                                                                    v.selected ?
                                                                        <img src="./assets/ui/pin2_f.png" />
                                                                        :
                                                                        <img src="./assets/ui/pin2.png" />
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            })}

                                            <YStyled.Col className={styleUi.info} align="center">
                                                <YStyled.Span size={15}>Collect</YStyled.Span>
                                                <YStyled.Span size={15}>Memories</YStyled.Span>
                                            </YStyled.Col>
                                        </div>
                                        {state === "share" &&
                                            <img className={styleUi.logo} src="./assets/ui/oosalogo.png" />
                                        }
                                    </div>
                                    {state === "edit" ?
                                        <div className={styleUi.btns}>
                                            <YStyled.BTN5 className={styleUi.btn} onClick={e => {
                                                if (count > 0)
                                                    shuffle();
                                            }}>
                                                <img src="./assets/ui/dice.png" />
                                                <YStyled.Span size={15}>{(count === -1) ? "" : count}</YStyled.Span>
                                            </YStyled.BTN5>
                                            <YStyled.BTN5 className={styleUi.btn} onClick={e => {
                                                set_state("share");
                                            }}>
                                                <img src="./assets/ui/heart.png" />
                                                <YStyled.Span size={15}>分享</YStyled.Span>
                                            </YStyled.BTN5>
                                        </div>
                                        :
                                        <div className={styleUi.btns_share}>
                                            <YStyled.BTN5 className={styleUi.btn} onClick={e => {
                                                handleScreenshot();
                                            }}>
                                                <img src="./assets/ui/heart.png" />
                                                <YStyled.Span size={15}>分享</YStyled.Span>
                                            </YStyled.BTN5>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(CollectMemories);
